export default __webpack_public_path__ + "static/media/alclad_aluminum_sheet.74e6e5fd.png";